
export class Signal {
    constructor(
        public currency: string,
        public description: string,
        public entryPrice: string,
        public stopLoss: string,
        public signalId: string,
        public status: string,
        public type: string,
        public tp1: number,
        public tp2: number,
        public tp3: number,
        public tp4: number,
        public color: string,
        public alias: string,
        public picture: string,
        public cdate: Date
    ) { }

}
